/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Anthropic_DescriptionInputs */

const en_admin_settings_groups_anthropic_description = /** @type {(inputs: Admin_Settings_Groups_Anthropic_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anthropic Claude API`)
};

/**
* | output |
* | --- |
* | "Anthropic Claude API" |
*
* @param {Admin_Settings_Groups_Anthropic_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_anthropic_description = /** @type {((inputs?: Admin_Settings_Groups_Anthropic_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Anthropic_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_anthropic_description(inputs)
});
export { admin_settings_groups_anthropic_description as "admin.settings.groups.anthropic.description" }